module.exports = __webpack_public_path__ + "img/1.1893a074.jpg";